<template>
    <div id="ModalMoveFile" class="modal fade in" data-backdrop="static" data-keyboard="false" role="dialog">>
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <p class="modal-title"><i class="fa fa-cut"></i> Mover arquivo {{file.arquivo_nome}}</p>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <button :disabled="!selectedFolder.id" class="btn" @click="prepareFolderRequest('STORE')"
                            :class="appLayout.btn"><i class="fa fa-plus-circle"></i>
                            Nova Pasta</button>&nbsp;&nbsp;&nbsp;
                        <button :disabled="!selectedFolder.id" class="btn" @click="prepareFolderRequest('UPDATE')"
                            :class="appLayout.btn"><i class="fa fa-edit"></i> Renomear
                            Pasta</button>&nbsp;&nbsp;&nbsp;
                        <button :disabled="!selectedFolder.id" class="btn btn-danger"
                            @click="prepareFolderRequest('DELETE')"><i class="fa fa-trash"></i> Deletar
                            Pasta</button>
                    </div>
                    <div class="box box-primary">
                        <div class="box-header with-border">
                            <p class="box-title"><i class="fa fa-folder-open"></i> Selecione onde mover o arquivo
                            </p>
                         <!--    <div class="box-tools">
                                <button type="button" class="btn btn-box-tool" data-widget="collapse"><i
                                        class="fa fa-minus"></i>
                                </button>
                            </div> -->
                        </div>
                        <div class="box-body no-padding">
                            <folder-explorer ref="FolderExplorer" @nodecontextmenu="showContextMenu" @nodeclick="selectNode" v-model="order">
                                <template slot="toggle" slot-scope="{ node }">
                                    <a href="#" class="fa text-dark"
                                        :class="{'fa-plus': !node.isExpanded, 'fa-minus': node.isExpanded}"></a>
                                </template>
                                <template slot="title" slot-scope="{ node }">
                                    &nbsp;&nbsp;<span style="{cursor: -webkit-grab; cursor: move}" class="item-icon">
                                        <i class="fa fa-file" v-if="node.isLeaf"></i>
                                        <i class="fa fa-2x text-yellow"
                                            :class="{'fa-folder': !node.children.length || !node.isExpanded, 'fa-folder-open': node.children.length && node.isExpanded}"
                                            v-if="!node.isLeaf"></i>
                                    </span>
                                    {{ node.title }}
                                </template>
                                <template slot="draginfo">
                                    Nível: {{selectedLevel.title}}
                                </template>
                            </folder-explorer>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="float-left btn btn-default" data-dismiss="modal"><i
                            class="fa fa-times"></i> {{$t('words.cancel')}}</button>
                    <button type="button" :disabled="loading || !selectedFolder.id" @click="moveFile()" class="btn btn-success"><i
                            class="fa fa-check"></i>
                        Mover <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                file: {},
                folderId: null,
                selectedLevel: {
                    title: null
                },
                order: [],
                selectedFolder: {
                    operation: 'STORE',
                    parent: null,
                    password: null,
                    id: null,
                    title: null,
                    children: []
                },
                folders: {}
            }
        },
        beforeMount() {
            this.updateLevels();
        },
        methods: {
            async moveFile() {
                if (this.selectedFolder.id === this.file.fk_nivel_id) {
                    toastr({title: 'Por favor, escolha uma pasta diferente!', icon: 'warning'});
                    return;
                }
                let valid = await confirm(`Tem certeza que deseja mover o(s) arquivo(s) ${this.file.arquivo_nome} para a pasta ${this.selectedFolder.title}?`);
                if (valid) {
                    this.loading = true;
                    this.$store.dispatch('moveFile', {ids: this.file.id, folder: this.selectedFolder.id}).then(response => {
                        toastr({icon: response.status, title: response.message});
                        this.$store.commit('REFRESH_USER_FILES', Math.random().toString(36).substr(2, 5));
                        $('#ModalMoveFile').modal('toggle');
                    }).catch(error => {
                        console.log(error);
                        toastr({icon: error.response.data.status, title: error.response.data.message});
                        if (error.response.data.status == 'error') {
                           this.$store.commit('REFRESH_USER_FILES', Math.random().toString(36).substr(2, 5));
                        }
                    }).finally(fn => {
                        this.loading = false;
                    });
                }
            },
            updateLevels() {
                this.order = [];                
                this.order.push(this.$store.state.user.data.pastasAcessiveis);
                this.folders = this.$store.state.user.data.pastasAcessiveis;
                this.selectedFolder = {
                    operation: 'STORE',
                    parent: null,
                    password: null,
                    id: null,
                    title: null,
                    children: []
                }
            },
            prepareFolderRequest(payload) {
                this.selectedFolder.parent = this.selectedFolder.id;
                this.selectedFolder.parentText = this.selectedFolder.title;
                this.$emit('prepareFolderRequest', {operation: payload, folder: this.selectedFolder});
            },
            selectNode(node, event) {
                this.selectedFolder = _.cloneDeep(node);
            },
            showContextMenu(node, event) {
                event.preventDefault();
            }
        }
    }
</script>